var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFacebook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 40,
    viewBox: "0 0 22 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0468 40V22.5051H19.8292L20.9293 15.2607H14.0468V10.562C14.0468 8.58497 15.0128 6.64861 18.0851 6.64861H21.2111V0.487475C21.2111 0.487475 18.3668 0 15.6568 0C10.0085 0 6.30563 3.46649 6.30563 9.73595V15.2471H0V22.4915H6.30563V39.9865H14.0602L14.0468 40Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook.58bd9b83c04e9b5fe0ba15a8c9dbb28b.svg";